import { Listbox, ListboxButton, ListboxOption, ListboxOptions } from '@headlessui/react';
import { ChevronDownIcon } from '@heroicons/react/20/solid';
import { cn } from '../../../lib/utils.ts';

export type DocumentTypeChipOption = { value: string; label: string };

type DocumentTypeChipProps = {
    label: string;
    options: DocumentTypeChipOption[];
    value?: string | null;
    onChange?: (value: string) => void;
    disabled?: boolean;
    'aria-invalid'?: boolean;
};

export function DocumentTypeChip({ label, options, value, onChange, disabled, 'aria-invalid': invalid }: DocumentTypeChipProps) {
    const selected = options.find((option) => option.value === value) ?? null;

    return (
        <Listbox value={value ?? ''} onChange={(next: string) => onChange?.(next)} disabled={disabled}>
            <ListboxButton
                aria-label={label}
                aria-invalid={invalid}
                className={cn(
                    'inline-flex h-8 items-center gap-1.5 rounded-full border px-3 text-[13px] font-semibold transition-colors',
                    'focus:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-1',
                    'disabled:cursor-not-allowed disabled:opacity-60',
                    'border-gray-300 bg-white text-gray-900 hover:border-primary hover:text-darkprimary',
                    invalid && 'border-red-400 text-red-700',
                )}
            >
                <span>{selected?.label ?? `${label} kiezen`}</span>
                <ChevronDownIcon className="h-3.5 w-3.5 text-gray-400" aria-hidden="true" />
            </ListboxButton>
            <ListboxOptions
                anchor="bottom start"
                className="z-50 mt-1 min-w-36 rounded-md border border-gray-200 bg-white py-1 text-[13px] shadow-lg focus:outline-none"
            >
                {options.map((option) => (
                    <ListboxOption
                        key={option.value}
                        value={option.value}
                        className="cursor-pointer px-3 py-1.5 text-gray-800 data-[selected]:bg-superliteprimary data-[selected]:font-semibold [&[data-focus]:not([data-selected])]:bg-gray-50"
                    >
                        {option.label}
                    </ListboxOption>
                ))}
            </ListboxOptions>
        </Listbox>
    );
}
